"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var React = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var RootState = __importStar(require("./root/root-state"));
var root_view_1 = require("./root/root-view");
var theme_1 = require("./theme");
var GlobalStyle = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    font-size: 1rem;\n    font-family:Arial,sans-serif;\n  }\n"], ["\n  body {\n    font-size: 1rem;\n    font-family:Arial,sans-serif;\n  }\n"])));
function App() {
    var _a = __read(React.useState(RootState.init()), 2), rootState = _a[0], setRootState = _a[1];
    return (React.createElement(styled_components_1.ThemeProvider, { theme: theme_1.calendarTheme },
        React.createElement(React.Fragment, null,
            React.createElement(GlobalStyle, null),
            React.createElement(root_view_1.RootView, { state: rootState, dispatch: function (a) {
                    console.log("State before: ", rootState);
                    console.log("Action: " + JSON.stringify(a));
                    var newRootState = RootState.reducer(rootState, a);
                    setRootState(newRootState);
                    console.log("State after: ", newRootState);
                } }))));
}
exports.App = App;
var templateObject_1;
//# sourceMappingURL=app.js.map